import { render, staticRenderFns } from "./shipReport.vue?vue&type=template&id=2c457dc4"
import script from "./shipReport.vue?vue&type=script&lang=js"
export * from "./shipReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports